import { getVerdictStyle } from "@/utils/verdict";

export default function CredibilityMeter({
  score,
  verdict,
  size = "md",
  showScale = false,
}: {
  score: number;
  verdict: string;
  size?: "sm" | "md" | "lg";
  showScale?: boolean;
}) {
  const style = getVerdictStyle(verdict);
  const segments = 20;
  const filled = Math.round((Math.max(0, Math.min(100, score)) / 100) * segments);
  const numClass =
    size === "lg" ? "text-3xl md:text-4xl" : size === "sm" ? "text-lg" : "text-2xl";

  return (
    <div className="w-full">
      <div className="flex items-end gap-2">
        <span className={`font-mono-num font-bold leading-none ${numClass} ${style.text}`}>
          {score}
        </span>
        <span className="text-xs text-foreground-500 mb-0.5">/ 100 可信度</span>
      </div>
      <div className="mt-2 flex gap-[3px]" role="img" aria-label={`可信度 ${score} 分`}>
        {Array.from({ length: segments }).map((_, i) => (
          <span
            key={i}
            className={`h-1.5 flex-1 rounded-full ${i < filled ? style.bar : "bg-background-200"}`}
          ></span>
        ))}
      </div>
      {showScale && (
        <div className="mt-2 flex justify-between text-[11px] text-foreground-400">
          <span>0 辟谣</span>
          <span>30 待定</span>
          <span>60 存疑</span>
          <span>85 实锤</span>
        </div>
      )}
    </div>
  );
}